module.exports = __webpack_public_path__ + "bf7b044d6369af9d8ecbc60156c3ea10.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/logo/Spotin_TM_Logo_Sand_Small_RGB.png
// module id = 113
// module chunks = 0